// extracted by mini-css-extract-plugin
module.exports = {"menu":"ShakeDropdown_menu__30Eb2","header":"ShakeDropdown_header__17fU9","item":"ShakeDropdown_item__31mEN","empty":"ShakeDropdown_empty__32GAt"};